import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import linkError from './links/linkError'
import linkHttp from './links/linkHttp'
import linkAuth from './links/linkAuth'

let apolloHTTPClient = () => {
  return linkError().concat(linkAuth).concat(linkHttp)
}

let client = new ApolloClient({
  link: apolloHTTPClient(this),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'none',
    },
    query: {
      errorPolicy: 'none',
    },
    mutate: {
      errorPolicy: 'none',
    },
  },
})

export default client
